import dataServices from '@/shared/api/dataServices';

import {
  GET_TRAVEL
} from '../mutation-types';

export const state = () => ({
  travel: {}
});

const mutations = {
  [GET_TRAVEL](state, travelData) {
    state.travel = travelData;
  }
};

const actions = {
  async getTravelDataAction({ commit }) {
    const travelData = await dataServices.getTravelData();
    commit(GET_TRAVEL, travelData);
  }
};

const getters = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
